import { render, staticRenderFns } from "./alertBlock.vue?vue&type=template&id=0bdb59dc&scoped=true"
import script from "./alertBlock.vue?vue&type=script&lang=js"
export * from "./alertBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb59dc",
  null
  
)

export default component.exports